import bell_icon from '_assets/img/onboard/bell.svg';
import Button from '_atoms/Button/Button';
import i18n from '_i18n';
import React from 'react';
import './TrialNotificationScreen.scss';

interface TrialNotificationScreenProps {
    onAnswer: (answerIndexes: number[]) => void;
}

const texts: Record<LanguageCode, { heading: string; reminder: string }> = {
    no: {
        heading: 'Du får en påminnelse 4 dager før prøveperioden din utløper',
        reminder: 'Påminnelse',
    },
    en: {
        heading: 'You’ll get a reminder 4 days before your trial ends',
        reminder: 'Reminder',
    },
};

const TrialNotificationScreen: React.FC<TrialNotificationScreenProps> = ({
    onAnswer,
}) => {
    const language: LanguageCode = i18n.language === 'no' ? 'no' : 'en';
    const { heading, reminder } = texts[language];
    const t = i18n.t;

    // create reminder text from today's date
    const date = new Date();
    const trialNotificationInDays = 10;
    date.setDate(date.getDate() + trialNotificationInDays);
    const locale = language === 'no' ? 'nb-NO' : 'en-US';
    const reminderDate = date.toLocaleDateString(locale, {
        month: 'long',
        day: 'numeric',
    });
    const reminderText = `${reminder}: ${reminderDate}`;

    return (
        <div className="trial-notification-screen">
            <div className="content-container">
                <div className="notification-heading">{heading}</div>
                <div className="notification-reminder-box">
                    <img src={bell_icon} alt="bell" />
                    {reminderText}
                </div>
            </div>
            <div className="navigation-container">
                <Button classes="next-button" onClick={() => onAnswer([])}>
                    {t('Continue')}
                </Button>
            </div>
        </div>
    );
};

export default TrialNotificationScreen;
